// // import { Icon } from '@iconify/react';
// import React from 'react';
// import { Link } from 'react-router-dom';

// export default function TeamStyle2({
//   imgUrl,
//   department,
   
//   description,
  
//   href,
// }) {
//   return (
//     <div  className="cs_team cs_style_1 cs_type_2 text-center cs_radius_20 overflow-hidden" >
//       <div className="cs_member_img">
//         <Link to={href} className="d-block">
//           <img src={imgUrl} alt="Doctor" />
//         </Link>
//         <div className="cs_label cs_white_color cs_accent_bg">{department}</div>
//       </div>
//       <div className="cs_team_meta cs_white_bg">
//         <div>
         
//           <p className="cs_member_description" dangerouslySetInnerHTML={{ __html:description }}></p>
//         </div>
//         <div>
//           {/* <div className="cs_social_links">
//             {social?.map((item, index) => (
//               <Link to={item.href} key={index}>
//                 <Icon icon={item.icon} />
//               </Link>
//             ))}
//           </div> */}
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const MAX_LENGTH = 120;

export default function TeamStyle2({
  imgUrl,
  department,
  description,
  href,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => setIsExpanded(!isExpanded);

  const plainText = description.replace(/<[^>]+>/g, ''); // Strip HTML tags for counting
  const shouldTruncate = plainText.length > MAX_LENGTH;

  const displayText = isExpanded
    ? description
    : plainText.slice(0, MAX_LENGTH) + (shouldTruncate ? '...' : '');

  return (
    <div className="cs_team cs_style_1 cs_type_2 text-center cs_radius_20 overflow-hidden">
      <div className="cs_member_img">
        <Link to={href} className="d-block">
          <img src={imgUrl} alt="Doctor"   />
        </Link>
        <div className="cs_label cs_white_color cs_accent_bg">{department}</div>
      </div>
      <div className="cs_team_meta cs_white_bg">
        <div>
          <p
            className="cs_member_description"
            dangerouslySetInnerHTML={{ __html: displayText }}
          ></p>
          {shouldTruncate && (
            <button
              className="read-more-btn mt-2"
              onClick={toggleReadMore}
              style={{
                background: 'none',
                border: 'none',
                color: '#007bff',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              {isExpanded ? 'Read Less' : 'Read More'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
